import { formSubmitClear, formComplete } from 'actions/forms'
import { notify } from '../utils/notification'
import { getLockedAccounts } from 'actions/accountsAndLoans'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const LOCKEDACCOUNT_SAVE_REQUEST = 'LOCKEDACCOUNT_SAVE_REQUEST'
export const LOCKEDACCOUNT_SAVE_ERROR = 'LOCKEDACCOUNT_SAVE_ERROR'
export const LOCKEDACCOUNT_SAVE_COMPLETE = 'LOCKEDACCOUNT_SAVE_COMPLETE'

const saveLockedAccountRequest = () => ({
  type: LOCKEDACCOUNT_SAVE_REQUEST,
})

const saveLockedAccountError = errors => ({
  error: errors[0].error,
  type: LOCKEDACCOUNT_SAVE_ERROR,
})

const saveLockedAccountComplete = result => ({
  result,
  type: LOCKEDACCOUNT_SAVE_COMPLETE,
})

export const addLockedAccount = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(saveLockedAccountRequest())
  agent.AccountsAndLoans.createlockedaccount(payload).then((response) => {
    dispatch(saveLockedAccountComplete(response))
    dispatch(notify('Account has been locked'))

    if (redirect) {
      dispatch(getLockedAccounts(payload.employee_id))
    }
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving account, please try again later', 'warning'))
      // console.warn('Err <addLockedAccount>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}

export const deleteLockedAccount = payload => (dispatch) => {
  dispatch(saveLockedAccountRequest())
  agent.AccountsAndLoans.deletelockedaccount(payload).then((response) => {
    dispatch(saveLockedAccountComplete(response))
    dispatch(notify('Account unlocked.'))
    dispatch(getLockedAccounts(payload.employee_id))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error unlocking account, please try again later', 'warning'))
      // console.warn('Err <deleteLockedAccount>: ', description, error)
      dispatch(saveLockedAccountError(LOCKEDACCOUNT_SAVE_ERROR))
    }
  })
}




// WEBPACK FOOTER //
// ./src/actions/lockedAccountForm.js